export function usePaginationQuerySync(
  currentPage: Ref<number>,
  pageSize: Ref<number>,
  pageKey: Ref<string>,
  sizeKey: Ref<string>,
  defaultSize: number,
  totalPages: Ref<number>
) {
  const { setParams, removeParams } = useQueryParams();

  function clampPage(page: number) {
    return Math.max(1, Math.min(page, totalPages.value));
  }

  watch([currentPage, pageSize], ([page, size]) => {
    const clampedPage = clampPage(page);
    const params: Record<string, number> = {};

    if (clampedPage !== 1) {
      params[pageKey.value] = clampedPage;
    }

    if (size !== defaultSize) {
      params[sizeKey.value] = size;
    }

    if (Object.keys(params).length === 0) {
      removeParams([pageKey.value, sizeKey.value]);
    } else {
      setParams(params);
    }
  });
}
